import React from 'react';
import { StarIcon } from 'lucide-react';
export type Testimonial = {
  quote: string;
  author: string;
  role?: string;
  photo?: string;
};
type TestimonialsProps = {
  testimonials: Testimonial[];
  title?: string;
  background?: 'ivory' | 'white';
};
export function Testimonials({
  testimonials,
  title,
  background = 'white'
}: TestimonialsProps) {
  return <section className={`w-full ${background === 'white' ? 'bg-white' : 'bg-ivory'} py-16 sm:py-20`} data-id="element-218" data-mp="3ayqcrc2non1g">
      <div className="mx-auto max-w-6xl px-5" data-id="element-219" data-mp="31zwc9am7fcim">
        {title && <>
            <h2 className="text-center font-serif text-3xl sm:text-4xl text-ink" data-id="element-220" data-mp="3228za26tkd2j">
              {title}
            </h2>
            <div className="rule-gold mx-auto mt-6 w-32" aria-hidden="true" data-id="element-221" data-mp="2s1ymujslz9of" />
          </>}

        <ul className={`grid gap-6 sm:grid-cols-3 ${title ? 'mt-12' : ''}`} data-id="element-222" data-mp="v96jpyljjtix">
          {testimonials.map(testimonial => <li key={testimonial.quote} className="flex flex-col border border-gold-soft/70 bg-ivory p-7" data-id="element-223" data-mp="qbevbek3upjh">
              <div className="flex gap-1" aria-label="5 out of 5 stars" data-id="element-224" data-mp="h8awv9l20jp4">
                {Array.from({
              length: 5
            }).map((_, index) => <StarIcon key={index} className="h-3.5 w-3.5 fill-gold text-gold" aria-hidden="true" data-id="element-225" data-mp="78k4bdg20ero" data-mpi={index} />)}
              </div>
              <blockquote className="mt-5 flex-1 font-serif text-lg leading-relaxed text-ink" data-id="element-226" data-mp="zxqzq3k7oo8p">
                &ldquo;{testimonial.quote}&rdquo;
              </blockquote>
              <div className="mt-6 flex items-center gap-3 border-t border-gold-soft/70 pt-5" data-id="element-227" data-mp="q762ajg9xprd">
                {testimonial.photo ? <img src={testimonial.photo} alt={`Portrait of ${testimonial.author}`} className="h-12 w-12 shrink-0 rounded-full border border-gold-soft object-cover" loading="lazy" data-id="element-228" data-mp="v44xz6fl64ro" /> : <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-gold-tint font-serif text-sm text-gold-dark" data-id="element-229" data-mp="1xh7oqwklmcrl">
                    {testimonial.author.charAt(0)}
                  </span>}
                <span data-id="element-230" data-mp="1jihppbe7y30l">
                  <span className="block text-sm font-semibold text-ink" data-id="element-231" data-mp="1jh6e4pej7qyx">
                    {testimonial.author}
                  </span>
                  {testimonial.role && <span className="block text-[11px] uppercase tracking-[0.16em] text-ink-muted" data-id="element-232" data-mp="19rwkh541i08p">
                      {testimonial.role}
                    </span>}
                </span>
              </div>
            </li>)}
        </ul>
      </div>
    </section>;
}